import React from 'react';
import Lottie from 'lottie-react';
import './HowItWorks.css';
import businessAppAnimation from '../animations/business app.json';
import bookingAnimation from '../animations/booking.json';
import paymentAnimation from '../animations/Online Payment.json';

const animations = {
  'business app': businessAppAnimation,
  'booking': bookingAnimation,
  'Online Payment': paymentAnimation
};

const translations = {
  ar: {
    title: 'كيف تحجز ملعبك؟',
    subtitle: 'ثلاث خطوات بسيطة للحجز',
    steps: [
      {
        number: '1',
        animation: 'business app',
        title: 'اختر الملعب',
        description: 'تصفح الملاعب المتاحة أو ابحث عن أقرب ملعب إليك عبر GPS'
      },
      {
        number: '2',
        animation: 'booking',
        title: 'حدد الوقت',
        description: 'اختر التاريخ والوقت المناسب من الأوقات المتاحة'
      },
      {
        number: '3',
        animation: 'Online Payment',
        title: 'أكمل الحجز',
        description: 'ادفع بسهولة عبر المحفظة أو نقداً واستلم رمز QR'
      }
    ]
  },
  en: {
    title: 'How to Book Your Stadium?',
    subtitle: 'Three simple steps to book',
    steps: [
      {
        number: '1',
        animation: 'business app',
        title: 'Choose Stadium',
        description: 'Browse stadiums or find the nearest one using GPS'
      },
      {
        number: '2',
        animation: 'booking',
        title: 'Select Time',
        description: 'Choose the suitable date and time from available slots'
      },
      {
        number: '3',
        animation: 'Online Payment',
        title: 'Complete Booking',
        description: 'Pay easily via wallet or cash and receive QR code'
      }
    ]
  }
};

function HowItWorks({ language }) {
  const t = translations[language];
  const isRTL = language === 'ar';

  return (
    <section id="how-it-works" className="how-it-works">
      <div className="container">
        <div className="section-header" data-aos="fade-up">
          <h2>{t.title}</h2>
          <p>{t.subtitle}</p>
        </div>
        <div className="steps" style={{ direction: isRTL ? 'rtl' : 'ltr' }}>
          {t.steps.map((step, index) => (
            <React.Fragment key={index}>
              <div className="step" data-aos="zoom-in" data-aos-delay={index * 150}>
                <div className="step-number">{step.number}</div>
                <div className="step-animation">
                  <Lottie 
                    animationData={animations[step.animation]} 
                    loop={true}
                  />
                </div>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
              {index < t.steps.length - 1 && <div className="step-arrow">{isRTL ? '←' : '→'}</div>}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
